import { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'

const StyledTileMiddleInfo = styled.div`
  padding: 0 10px;
  justify-self: center;
  align-self: center;
`

const TileMiddleInfo: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  return <StyledTileMiddleInfo>{children}</StyledTileMiddleInfo>
}

export default TileMiddleInfo
